import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';

import {TypeEnergylevelComponent} from './type-energylevel.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
  ],
  declarations: [
    TypeEnergylevelComponent,
  ],
  exports: [
    TypeEnergylevelComponent,
  ],
})
export class TypeEnergylevelModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/questions/questions-details/type-components/type-energylevel/type-energylevel.module.ts